class SkipFormattingValue {
  constructor(_value) {
    this._value = _value;
  }
  formatter() {
    return this._value;
  }
}

export { SkipFormattingValue };
//# sourceMappingURL=types.js.map
